import { render } from "./admin-cms.vue?vue&type=template&id=6aa45f49&scoped=true"
import script from "./admin-cms.vue?vue&type=script&lang=js"
export * from "./admin-cms.vue?vue&type=script&lang=js"

import "./admin-cms.vue?vue&type=style&index=0&id=6aa45f49&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6aa45f49"

export default script